import React from 'react';
import { Box, Typography } from '@mui/material';

interface UtilityHeaderProps {
  title: string;
  description: string;
}

const UtilityHeader: React.FC<UtilityHeaderProps> = ({ title, description }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography 
        variant="h4" 
        fontWeight={800} 
        gutterBottom 
        sx={{ 
          background: 'linear-gradient(90deg, #fff 0%, #00e5ff 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          mb: 1
        }}
      >
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {description}
      </Typography>
    </Box>
  );
};

export default UtilityHeader;
